import { adminCall, adminGet } from './adminCall';

export async function adminListDemos() {
  const result = await adminGet('/api/admin/demos');
  return result.demos || [];
}

export async function adminUpdateDemoStatus({ demoId, status }) {
  return adminCall(`/api/admin/demos/${encodeURIComponent(demoId)}/status`, { status });
}

export async function adminDeleteDemo({ demoId }) {
  return adminCall(`/api/admin/demos/${encodeURIComponent(demoId)}/delete`);
}
